import clsx from "clsx"
import { useTranslation } from "react-i18next"

import TableHead from "@material-ui/core/TableHead"
import TableRow from "@material-ui/core/TableRow"
import TableCell from "@material-ui/core/TableCell"
import Checkbox from "@material-ui/core/Checkbox"
import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
import Select from "@material-ui/core/Select"
import MenuItem from "@material-ui/core/MenuItem"

import AddIcon from "@material-ui/icons/Add"

import { SearchTextField } from "components/partials"
import { ActionCreators, useAdminState, useAdminDispatch } from "../Context"
import { AdminHeaderForm } from "components/partials"
import { useAdminFilter } from "common/hooks"
import {
    getFormTitle,
    getFilterPlaceholder
} from "common/helpers/admin-page-func.helper"
import useStyles from "./Table.style"

const Header = () => {
    const classes = useStyles()
    const { t } = useTranslation()
    const { rows } = useAdminState()
    const dispatch = useAdminDispatch()
    const [filter, onChangeFilter] = useAdminFilter()

    function onToggleSelectAll(event) {
        const { checked } = event.target
        dispatch(
            checked ? ActionCreators.selectAll() : ActionCreators.deselectAll()
        )
    }

    function onClickCreate() {
        dispatch(
            ActionCreators.setToEdit({
                name: "",
                enabled: true,
                userLicenses: 0,
                catalogLicenses: 0
            })
        )
    }

    const totalSelected = rows.filter(({ isSelected }) => isSelected).length
    const totalRows = rows.length

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox">
                    <Checkbox
                        color="primary"
                        indeterminate={totalSelected > 0 && totalSelected < totalRows}
                        checked={totalRows > 0 && totalSelected === totalRows}
                        onChange={onToggleSelectAll}
                    />
                </TableCell>

                <TableCell>
                    <AdminHeaderForm
                        label={t("view.admin.name")}
                        SortProps={{
                            key: "name"
                        }}
                    >
                        <SearchTextField
                            fullWidth
                            placeholder={getFilterPlaceholder(t("view.admin.name"))}
                            value={filter.name || ""}
                            onChange={onChangeFilter("name")}
                        />
                    </AdminHeaderForm>
                </TableCell>

                <TableCell>
                    <AdminHeaderForm
                        label={t("view.admin.users")}
                        SortProps={{
                            key: "users"
                        }}
                    >
                        <SearchTextField
                            fullWidth
                            placeholder={getFilterPlaceholder(t("view.admin.users"))}
                            value={filter.users || ""}
                            onChange={onChangeFilter("users")}
                        />
                    </AdminHeaderForm>
                </TableCell>

                <TableCell style={{ minWidth: 200, width: "1%", whiteSpace: "nowrap" }}>
                    <AdminHeaderForm
                        label={t("view.adminCompanies.filterUserLicenses")}
                        tooltip={t("view.adminCompanies.filterUserLicensesTooltip")}
                        SortProps={{
                            key: "userLicenses"
                        }}
                    >
                        <SearchTextField
                            fullWidth
                            placeholder={getFilterPlaceholder(
                                t("view.adminCompanies.filterUserLicenses")
                            )}
                            value={filter.userLicenses || ""}
                            onChange={onChangeFilter("userLicenses")}
                        />
                    </AdminHeaderForm>
                </TableCell>

                <TableCell>
                    <AdminHeaderForm
                        label={t("view.admin.catalogs")}
                        SortProps={{
                            key: "catalogs"
                        }}
                    >
                        <SearchTextField
                            fullWidth
                            placeholder={getFilterPlaceholder(t("view.admin.catalogs"))}
                            value={filter.catalogs || ""}
                            onChange={onChangeFilter("catalogs")}
                        />
                    </AdminHeaderForm>
                </TableCell>

                <TableCell style={{ minWidth: 200, width: "1%", whiteSpace: "nowrap" }}>
                    <AdminHeaderForm
                        label={t("view.adminCompanies.filterCatalogLicenses")}
                        tooltip={t("view.adminCompanies.filterCatalogLicensesTooltip")}
                        SortProps={{
                            key: "catalogLicenses"
                        }}
                    >
                        <SearchTextField
                            fullWidth
                            placeholder={getFilterPlaceholder(
                                t("view.adminCompanies.filterCatalogLicenses")
                            )}
                            value={filter.catalogLicenses || ""}
                            onChange={onChangeFilter("catalogLicenses")}
                        />
                    </AdminHeaderForm>
                </TableCell>

                <TableCell style={{ minWidth: 200, width: "1%", whiteSpace: "nowrap" }}>
                    <AdminHeaderForm
                        label={t("view.adminCompanies.filterEnabled")}
                        SortProps={{
                            key: "enabled"
                        }}
                    >
                        <Select
                            fullWidth
                            displayEmpty
                            value={filter.enabled || ""}
                            onChange={onChangeFilter("enabled")}
                            className={clsx({ [classes.grey]: !filter.enabled })}
                        >
                            <MenuItem value="" selected>
                                {getFilterPlaceholder(t("view.adminCompanies.filterEnabled"))}
                            </MenuItem>
                            <MenuItem value="true">True</MenuItem>
                            <MenuItem value="false">False</MenuItem>
                        </Select>
                    </AdminHeaderForm>
                </TableCell>

                <TableCell className={classes.cellFit}>
                    <Box display="flex" flexDirection="column" alignItems="flex-start">
                        {t("view.admin.actions")}
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<AddIcon />}
                            onClick={onClickCreate}
                        >
                            {getFormTitle(t("view.admin.company"))}
                        </Button>
                    </Box>
                </TableCell>
            </TableRow>
        </TableHead>
    )
}

export default Header
